import type { Attachment } from 'svelte/attachments';

// The press, started by the finger rather than by :active.
//
// interaction.css draws the press on :active: a 1px move for most controls,
// and for keys, tiles and cart lines (data-press="invert") the whole surface
// turning to the emphasis colour. On a touch screen :active can arrive late,
// and a till must answer a finger within 50 ms, so every pressable control
// also marks itself data-pressed on pointerdown. That is the hook the design
// gives for forcing the press (interaction.css applies the invert to it
// directly; app.css adds the same for the 1px move). The look is the
// design's; only the moment it starts is the till's.
//
// Used as {@attach pressable} on the element that carries data-press.
export const pressable: Attachment<HTMLElement> = (node) => {
	const down = () => node.setAttribute('data-pressed', '');
	const up = () => node.removeAttribute('data-pressed');
	const ends = ['pointerup', 'pointercancel', 'pointerleave'] as const;

	node.addEventListener('pointerdown', down);
	for (const end of ends) node.addEventListener(end, up);
	return () => {
		node.removeEventListener('pointerdown', down);
		for (const end of ends) node.removeEventListener(end, up);
	};
};
